export const socialUrls = {
  facebook: 'https://www.facebook.com/deportedmovie/',
  twitter: 'https://twitter.com/deportedmovie?lang=en',
  instagram: 'https://www.instagram.com/deportedmovie/',
  youtube: 'https://www.youtube.com/channel/UCh9cxr81Qz-MWHhYQjNMBdg',
  imdb: 'https://www.imdb.com/title/tt4344624/',
  preOrder: 'https://facebook.com',
};
